import GameSignals from '@/signals/GameSignals'
import { BaseChildState } from '@stateMachine/BaseChildState'

export class FreeSpinsRetriggerState extends BaseChildState {
    private static readonly POPUP_FALLBACK_MS: number = 15000

    private _fallbackTimeoutId: number = null
    private _isCompleted: boolean = false

    public canTrigger(): boolean {
        // Intro jumps to START_SPIN, so this child only runs on a later FS spin.
        return (
            this._model.roundState.isFreeSpins &&
            Boolean(this._model.spinData?.bonus) &&
            Number(this._model.spinData.bonus.freebet_given) > 0
        )
    }

    public begin() {
        ;(GameSignals as any).featurePopupDismissStarted?.connect(this.onRetriggerComplete)
        ;(GameSignals as any).featureIntroContinue?.connect(this.onRetriggerComplete)

        this._isCompleted = false

        const freeSpinsCount = Number(this._model.spinData.bonus.freebet_given)
        ;(GameSignals as any).featureIntroRequested?.emit({
            kind: 'freespins',
            freeSpinsCount,
            retrigger: true,
        })

        this._fallbackTimeoutId = window.setTimeout(this.onRetriggerComplete, FreeSpinsRetriggerState.POPUP_FALLBACK_MS)
    }

    private onRetriggerComplete = () => {
        if (this._isCompleted) {
            return
        }

        this._isCompleted = true
        if (this._fallbackTimeoutId !== null) {
            clearTimeout(this._fallbackTimeoutId)
            this._fallbackTimeoutId = null
        }

        // Commit the meter only after the award popup, then continue the FS round.
        GameSignals.showFreeSpinsRetrigger.emit(this._model.spinData.bonus.freebet_given)
        this.end()
    }

    public cleanUp() {
        if (this._fallbackTimeoutId !== null) {
            clearTimeout(this._fallbackTimeoutId)
            this._fallbackTimeoutId = null
        }

        ;(GameSignals as any).featurePopupDismissStarted?.disconnect(this.onRetriggerComplete)
        ;(GameSignals as any).featureIntroContinue?.disconnect(this.onRetriggerComplete)
    }
}
